
import { Vue, Prop, Watch, Component } from 'vue-property-decorator'
import { FileUrl } from '@/utils/commons'
import { UserModule } from '@/store/modules/user'
import HsPlupload from '@/components/plupload/main.vue'

@Component({
  name: 'darggable-item',
  components: {
    HsPlupload
  }
})

export default class DarggableItem extends Vue {
  get token () {
    return UserModule.token
  }

  @Prop({ type: String })
  private titleType!: string

  @Prop({ type: [String, Number] })
  private schoolId!: string|number

  @Prop({ type: Object })
  private form!: object|any

  @Prop({ type: Object })
  private option!: object|any

  @Prop({ type: String })
  private serverConfigUrl!: string

  @Prop({ type: String })
  private flag!: string

  get isEdit () {
    return this.flag !== 'show'
  }

  private filters = {
    mime_types: [
      { title: 'image type', extensions: 'bmp,jpg,png,jpeg,gif,gpng,ico' }
    ]
  }

  get uploadBtn () {
    return 'browseButton_' + this.titleType
  }

  private picList: any[] = this.form.att ? this.form.att.map((v: any) => {
    return {
      src: v.path || v.src,
      name: v.realName || v.name
    }
  }) : []

  private up: any = {}

  private files: any = this.form.att ? this.form.att.map((v: any) => {
    return {
      src: v.path,
      name: v.realName
    }
  }) : []

  private changed = !1

  @Watch('changed')
  private changeChanged () {
    const picList: any[] = []
    this.files.forEach((e: any) => {
      picList.push({ src: e.imgsrc, file: e, name: e.name })
    })
    this.picList = picList
  }

  private inputUploader (up: any) {
    this.up = up
    this.files = up.files
  }

  private filesAdded (up: any, files: any) {
    if (files.length > 1) {
      this.$message.error('每次只允许选择一张图片')
      return
    }
    if (!this.option.uploadCnt || this.option.uploadCnt < 2) {
      if (up.files.length > 1) {
        up.removeFile(up.files[0])
      }
    }
    files.forEach((f: any) => {
      // eslint-disable-next-line handle-callback-err
      FileUrl(f.getNative(), (err: any, imgsrc: any) => {
        f.imgsrc = imgsrc
        this.changed = !this.changed
      })
    })
    this.upload()
  }

  private async upload () {
    this.up.start()
  }

  private UploadComplete (up: any, files: any) {
    console.log(up, files)
  }

  private FileUploaded (up: any, files: any, res: any) {
    const response = JSON.parse(res.response)
    if (this.option.uploadCnt && this.option.uploadCnt > 1) {
      if (!this.form.att) this.form.att = []
      this.form.att.push({
        createTime: new Date().getTime(),
        path: response.fileInfos[0].savePath,
        realName: response.fileInfos[0].originalFileName
      })
      this.picList = this.form.att.map((v: any) => {
        return {
          src: v.path || v.src,
          name: v.realName || v.name
        }
      })
    } else {
      this.form.att = [{
        createTime: new Date().getTime(),
        path: response.fileInfos[0].savePath,
        realName: response.fileInfos[0].originalFileName
      }]
    }
  }

  private delImg (index: any) {
    this.form.att.splice(index, 1)
    this.picList.splice(index, 1)
  }

  private error (up: any, res: any) {
    if (res.code === -601) {
      this.$message.error('只能上传bmp,jpg,png,jpeg,gif,gpng,ico等图片格式')
      return
    }
    this.$message.error(res.message)
  }
}
